import * as THREE from 'three'
require('three-orbitcontrols');

export var scene;//相机
export var camera;//场景
export var renderer;//渲染器
var controls;//控制器

export let currentMesh;
let vaseMesh;

export let color1;
export let color2;
import {currentColor1,currentColor2} from './index'

const material = new THREE.MeshPhongMaterial({
    reflectivity: 1,
}); //这个放在外面，是公共的值

// var material = new THREE.MeshPhongMaterial({ color: 0xff5533, specular: 0x111111, shininess: 200 });

export function world3d(canvas3dworld) {
    scene = new THREE.Scene();
    //创建3D世界
    var w = canvas3dworld.scrollWidth;
    var h = canvas3dworld.scrollHeight;

    //创建渲染器
    renderer = new THREE.WebGLRenderer({
        canvas: canvas3dworld,
        antialias: true,//抗锯齿
        preserveDrawingBuffer: true,//3D加上这个在缩略图中可以变成白色
    });
    renderer.setSize(w, h);
    renderer.setClearColor(new THREE.Color("#123655"));//把渲染器的背景变成白色
    renderer.setPixelRatio(2);

    // 创建场景
    // 量纲，单位 1px 1m 1kg
    camera = new THREE.PerspectiveCamera(60, w / h, 0.1, 2200);

    //定义相机的x,y,z位置
    camera.position.x = 120;
    camera.position.y = 100;
    camera.position.z = 80;
    camera.lookAt(scene.position);//把相机的位置渲染到场景中

    //控制器，鼠标左键和右键，滑轮操作
    controls = new THREE.OrbitControls(camera, canvas3dworld);

    //是否可以缩放
    controls.enableZoom = true;
    //设置相机距离原点的最远距离
    controls.minDistance = 20;
    controls.maxDistance = 700;

    //渲染场景
    function animate() {
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
    }
    animate();

    // 点光源
    var bluePoint = new THREE.PointLight(0xffffff, 0.2, 130);
    bluePoint.position.set(10, 100, 10);
    scene.add(bluePoint);

    // 平行光，造成投影
    var sunLight1 = new THREE.DirectionalLight(0xffffff, 0.2);
    sunLight1.position.set(0, 120, 120);
    scene.add(sunLight1);

    var sunLight2 = new THREE.DirectionalLight(0xffffff, 0.4);
    sunLight2.position.set(-120, 120, 0);
    scene.add(sunLight2);

    var sunLight3 = new THREE.DirectionalLight(0xffffff, 0.1);
    sunLight3.position.set(0, 120, -120);
    scene.add(sunLight3);

    // 环境光会均匀的照亮场景中的所有物体。
    var light = new THREE.AmbientLight(0xffffff, 0.5);
    scene.add(light);


    // 天空盒
    var vertexShader = `
        varying vec3 vWorldPosition;
		void main() {
		    vec4 worldPosition = modelMatrix * vec4( position, 1.0 );
		    vWorldPosition = worldPosition.xyz;
		    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
		}
    `;
    var fragmentShader = `
        uniform vec3 topColor;
        uniform vec3 bottomColor;
        uniform float offset;
        uniform float exponent;
        varying vec3 vWorldPosition;
        void main() {
            float h = normalize( vWorldPosition + offset ).y;
            gl_FragColor = vec4(0.85 * mix( bottomColor, topColor, max( pow( max( h , 0.0), exponent ), 0.0 ) ), 1.0 );
        }
    `;
    var uniforms = {
        // "topColor": { value: new THREE.Color(0xFFFFFF) },
        // "bottomColor": { value: new THREE.Color(0x87CEEB) },
        "topColor": { value: new THREE.Color(0xE3EAEA) },
        "bottomColor": { value: new THREE.Color(0x71A7D6) },
        "offset": { value: 33 },
        "exponent": { value: 1.0 }
    };

    var skyGeo = new THREE.SphereBufferGeometry(1000, 32, 15);
    var skyMat = new THREE.ShaderMaterial({
        uniforms: uniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        side: THREE.BackSide,
        // transparent: true,
        // opacity: 0.9
    });

    var sky = new THREE.Mesh(skyGeo, skyMat);
    sky.position.y = -100;
    scene.add(sky);
}

//创建模型
export function makeVase(stl, type) {
    var loader = new THREE.STLLoader();
    loader.load(stl, function (geometry) {
        currentMesh = new THREE.Mesh(geometry, material);
        currentMesh.position.set(1, 0, 0);
        currentMesh.rotation.set(-Math.PI / 2, 0, 0);
        //Math.PI
        currentMesh.scale.set(1, 1, 1);
        currentMesh.castShadow = true;
        currentMesh.receiveShadow = true;
        geometry.center(); //居中显示

        currentMesh.material = new THREE.MeshLambertMaterial({
            vertexColors: true,
        });

        if (type === "vase") {
            if (vaseMesh != null) {
                scene.remove(vaseMesh);
                vaseMesh = null;
            }
            vaseMesh = currentMesh;
            vaseMesh.scale.set(0.5, 0.5, 0.5);
        }

        let position = vaseMesh.geometry.attributes.position;
        let len = position.count * 3;
        let colors = new Float32Array(len);
        vaseMesh.geometry.setAttribute("color", new THREE.BufferAttribute(colors, 3));
        vaseMesh.geometry.computeVertexNormals();

        //使用方法
        color1 = new THREE.Color(currentColor1); //底部颜色
        color2 = new THREE.Color(currentColor2);//头部颜色
        updateColor(color1.r, color1.g, color1.b, color2.r, color2.g, color2.b);
        scene.add(vaseMesh);
    });
}

//修改渐变色方法
export function updateColor(r1, g1, b1, r2, g2, b2) {
    let box = vaseMesh.geometry.boundingBox;
    let height = box.getSize().z;
    let bottom = box.min.z;
    let color = vaseMesh.geometry.attributes.color;
    let position = vaseMesh.geometry.attributes.position;
    let stop1 = 0.1;
    let stop2 = 0.9;
    for (let i = 0; i < position.count; i++) {
        let y = position.getZ(i);
        let t = (y - bottom) / height;
        if (t <= stop1) {
            color.setXYZ(i, r1, g1, b1);
        } else if (t >= stop2) {
            color.setXYZ(i, r2, g2, b2);
        } else {
            t = (t - stop1) / (stop2 - stop1);
            let r = r1 * (1 - t) + r2 * t;
            let g = g1 * (1 - t) + g2 * t;
            let b = b1 * (1 - t) + b2 * t;
            color.setXYZ(i, r, g, b);
        }
    }
    color.needsUpdate = true;
}







// WEBPACK FOOTER //
// ./src/views/vase3d/scripts/3dvase.js